import { render } from "./SobrePPG.vue?vue&type=template&id=fd33f1ec&scoped=true"
import script from "./SobrePPG.vue?vue&type=script&lang=js"
export * from "./SobrePPG.vue?vue&type=script&lang=js"

import "./SobrePPG.vue?vue&type=style&index=0&id=fd33f1ec&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd33f1ec"]])

export default __exports__